<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    class="gs-profile-page body__content"
  >
    <div class="back-to-search-section">
      <div class="container">
        <router-link
          v-if="showBackToSearch"
          :to="{ name: 'Members' }"
          class="back-to-search-link"
        >
          <span>
            <svg-white-arrow-left class="mr-1"></svg-white-arrow-left>Back to
            search
          </span>
        </router-link>
        <a
          v-else-if="showBackToEvent"
          aria-label="go back to event page"
          href="javascript:void(0)"
          class="back-to-search-link linkified"
          @click="goBackToEventPage"
        >
          <span><svg-white-arrow-left class="mr-1"></svg-white-arrow-left> Back to event</span>
        </a>
      </div>
    </div>
    <div v-if="member">
      <div class="white-background-section">
        <div class="container profile-card-container">
          <el-card class="profile-card">
            <div class="profile-card-body pb-0">
              <el-row>
                <el-col
                  :xs="5"
                  :sm="5"
                  :md="5"
                  :lg="4"
                >
                  <el-avatar
                    shape="circle"
                    class="avatar"
                    :src="member.avatar"
                    alt="Profile picture"
                  >
                    <img src="../../../static/img/default-image.png" />
                  </el-avatar>
                </el-col>
                <el-col
                  id="main-content"
                  :xs="19"
                  :sm="19"
                  :md="19"
                  :lg="13"
                >
                  <div class="user-info">
                    <div class="d-flex justify-content-between">
                      <h1>{{ member.full_name }}</h1>
                      <div class="followers-section d-flex hidden-md-and-down">
                      </div>
                    </div>

                    <div class="location d-flex">
                      <router-link
                        v-if="member.organisation"
                        :to="{name:'Organisation Profile', params:{id:member.organisation.id}}"
                      >
                        {{ member.organisation.name }}
                      </router-link>
                      <router-link
                        v-else-if="member.expertProfile.organisation"
                        :to="{name:'Organisation Profile', params:{id:member.expertProfile.organisation.id}}"
                      >
                        {{ member.expertProfile.organisation.name }}
                      </router-link>
                      <p
                        v-else
                        class="d-flex"
                      >
                        {{ member.expertProfile.organisation_name }}
                      </p>
                      <!-- <span class="ml-3 mr-3">|</span> -->
                      <div class="d-none d-md-block">
                        <svg-vertical-line
                          class="vertical-line"
                          aria-labeledby="vertical line"
                        ></svg-vertical-line>
                      </div>
                      <p class="d-flex">
                        {{ member.expertProfile.role }}
                      </p>
                    </div>

                    <div>
                      <p class="pt-4">
                        Member, {{ memberFor }}
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col
                  :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="7"
                >
                  <div class="followers-section d-flex justify-content-end">
                    <p
                      v-if="isProfileOwner"
                      class="clickable"
                      @click="$router.push({name:'Following'})"
                    >
                      <span>{{ member.following_count }}</span> Following
                    </p>
                    <div
                      v-if="isProfileOwner"
                      class="separator"
                    >
                      |
                    </div>
                    <p
                      :class="{'clickable' : isProfileOwner}"
                      @click="isProfileOwner ? $router.push({name:'Followers'}) : null"
                    >
                      <span>{{ member.followers_count }}</span> {{ member.followers_count > 1 ? 'Followers' : 'Follower' }}
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :md="24">
                <div class="profile-card-actions-container">
                  <!--div
                    v-if="!isProfileOwner && helpRequestsPaused"
                    class="view-page-link px-4 w-100"
                  >
                    <router-link to="/contact-us">
                      Contact admin to request help from this GlobalScot.
                    </router-link>
                  </!--div-->

                  <div class="profile-card-actions">
                    <!-- Hide it if help requests are paused-->
                    <!--el-button
                      v-if="!isProfileOwner && !helpRequestsPaused"
                      type="primary"
                      @click="dialogVisible = true"
                    >
                      Request help
                    </!--el-button-->
                    <el-button
                      v-if="isGlobalScotViewing && !directMessagesPaused"
                      type="button"
                      @click="sendMessage()"
                    >
                      Send message
                    </el-button>
                    <el-button
                      v-if="!isProfileOwner"
                      v-loading="startAction"
                      type="button"
                      @click="followUnfollowProfile()"
                    >
                      {{ member.has_followed ? 'Unfollow' : 'Follow' }}
                    </el-button>

                    
                    <el-button
                      v-if="isProfileOwner"
                      type="primary"
                      @click="editProfile"
                    >
                      Edit profile
                    </el-button>
                    <!--el-button
                      v-if="isProfileOwner"
                      type="button"
                    >
                      Invite colleague
                    </!--el-button-->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </div>
        <div class="container main-content">
          <el-row>
            <el-col :lg="12">
              <div
                v-if="isProfileOwner"
                class="about-section"
              >
                <h1>About you</h1>
                <p>{{ member.expertProfile.experience }}</p>
              </div>
              <div
                v-if="!isProfileOwner"
                class="about-section"
              >
                <h1>About {{ member.first_name }}</h1>
                <p>{{ member.expertProfile.experience }}</p>
              </div>
            </el-col>
          </el-row>
          <hr class="content-separator" />
          <el-row>
            <el-col
              :sm="24"
              :md="24"
            >
              <h1>Expertise</h1>
              <div class="w-100">
                <div
                  v-for="(expertise, index) in expertises"
                  :key="index"
                  class="tag-container"
                >
                  {{ expertise.name }}
                </div>
              </div>
            </el-col>
          </el-row>
          <hr class="content-separator" />
        </div>
      </div>
    </div>
    <!--focus-lock>
      <el-dialog
        ref="helpRequestDialog"
        :visible.sync="dialogVisible"
        fullscreen
        :show-close="false"
        @opened="dialogOpen('helpRequestDialog')"
      >
        <request-help
          v-if="renderComponent"
          :global-scot="member"
          @clicked="dialogVisible = false"
          @success="greatThing()"
        ></request-help>
      </el-dialog>
    </focus-lock-->

    <!--focus-lock>
      <el-dialog
        ref="helpRequestConfirmDialog"
        :show-close="false"
        custom-class="request-success-modal"
        :visible.sync="successDialogVisible"
        title="Your request has been sent. Services aim to respond within 3 working days. Depending where they’re based, time zone differences could affect their response time."
        @opened="dialogOpen('helpRequestConfirmDialog')"
      >
        <div class="text-center success-dialog">
          <svg-success-border></svg-success-border>
          <h2 class="mt-3">
            Your request has been sent
          </h2>
          <p class="mt-4 mb-4">
            Services aim to respond within 3 working days. Depending where
            they’re based, time zone differences could affect their response time.
          </p>

          <el-button
            class="mx-auto"
            @click="successDialogVisible = false"
          >
            Close
          </el-button>
        </div>
      </el-dialog>
    </focus-lock-->
  </div>
</template>

<script>
import store from "@/store";
import { mapGetters, mapState } from 'vuex'
import gsApi from "@/services/gs.api";
import RolePermissionMixin from "@/mixins/RolePermissionMixin";
import WhiteArrowLeft from "@/components/assets/svg-white-arrow-left";
import VerticalLine from '@/components/assets/svg-vertical-line';
import enumHelper from "@/helpers/enumHelper";

export default {
  name: "GsProfile",
  metaInfo: {
    title: "Member profile"
  },
  components: {

    "svg-white-arrow-left": WhiteArrowLeft,
    "svg-vertical-line":VerticalLine,
  },
  mixins: [RolePermissionMixin],
  data() {
    return {
      enumHelper,
      startAction : false,
      isGlobalScotViewing: false,
      isProfileOwner: false,
      //dialogVisible: false,
      //renderComponent: true,
      //successDialogVisible: false,
      member: null,
      mainLoader: true,
      showBackToSearch: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(['navigatedFrom']),
    expertises() {
      let expertises = this.member.expertProfile.expertise.data;
      return expertises;
    },
    memberFor() {
      return this.member?.expertProfile?.joined_at_for_humain
    },
    directMessagesPaused() {
      const settings = this.member.expertProfile.settings;
      return settings !== null && Object.prototype.hasOwnProperty.call(settings, 'direct_messages_paused_at')
        && settings.direct_messages_paused_at !== null;
    },
    showBackToEvent() {
      return this.navigatedFrom.name && this.navigatedFrom.name === 'event-view';
    },
  },
  watch: {
    $route(to, from) {
      if (from.path !== to.path && this.user.isLogged) {
        this.mainLoader = true;
        this.checkRole();
        this.fetchGsProfile();
      }
    }
  },
  created() {
    if (this.$route.params.showBackToSearch) {
      this.showBackToSearch = true;
    }

    if (store.state.user.isLogged) {
      this.fetchGsProfile();
    }
  },
  mounted() {
    this.checkRole();
  },
  beforeDestroy () {
    this.$store.dispatch("updateNavigatedFrom", {
      name: null
    });
  },
  methods: {
    /*greatThing() {
      this.successDialogVisible = true;
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },*/
    sendMessage() {
      this.mainLoader = true;
      gsApi.chat
        .create({
          type: "single",
          members: [this.$route.params.id]
        })
        .then(response => {
          if (response && response.data) {
            this.mainLoader = false;
            this.$store.commit("UPDATE_SELECTED_CHAT", response.data);
            this.$router.push({ name: "My Chats" });
          }
        })
        .catch(error => {
          this.mainLoader = false;
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.existingChat
          ) {
            this.$store.commit(
              "UPDATE_SELECTED_CHAT",
              error.response.data.existingChat
            );
            this.$router.push({ name: "My Chats" });
          }
        });
    },

    editProfile() {
      this.$router.push({ name: "Edit Profile" });
    },
    fetchGsProfile() {
      gsApi.users
        .profile(this.$route.params.id, {})
        .then(response => {
          this.mainLoader = false;
          if (
            !response.data.expertProfile ||
            !response.data.roles.includes("expert")
          ) {
            this.$alert(
              "Unable to load users profile. Please try again later.",
              "Error",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal"
              }
            );
            this.$router.push({ name: "Members" });
          }
          else if (response.data.suspended){
            this.$alert(
              "User is not currently active.",
              "Error",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal"
              }
            );
            this.$router.push({ name: "Members" });
          }
          else {
            this.member = response.data;
          }
        })
        .catch(error => {
          this.mainLoader = false;
          this.$alert(
            "Unable to load users profile. Please try again later.",
            "Error",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            }
          );
          this.$router.push({ name: "Members" });
        });
    },
    checkRole() {
      this.isProfileOwner = false;
      this.isGlobalScotViewing = false;

      if (this.user.id == this.$route.params.id) {
        this.isProfileOwner = true;
        return;
      }

      if (this.isRole("expert") && this.user.id !== this.$route.params.id) {
        this.isGlobalScotViewing = true;
      }
    },
    followUnfollowProfile() {
      this.startAction = true;
      let action = this.member.has_followed ? enumHelper.FollowAction.UNFOLLOW : enumHelper.FollowAction.FOLLOW;
      const data = {
        id : this.$route.params.id,
        module : "User",
        entity : "User"
      }
      gsApi.followable.followUnfollow(data, action).then((response)=>{
        this.member.has_followed = response.data.has_followed;
        this.member.followers_count = response.data.followers_count;
        if(action == enumHelper.FollowAction.FOLLOW){
          this.$alert(`Your are now successfully following ${this.member.full_name}.`, 'Success', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        }else{
          this.$alert(`Your have successfully unfollowed ${this.member.full_name}.`, 'Success', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        }

      }).catch((response)=>{
        if (response.status == 422) {
          let firstError =
          response.data.errors[Object.keys(response.data.errors)[0]]
          this.$alert(firstError[0], 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        } else {
          this.$alert('Sorry, your request could not be processed', `Error ${error.response.data.error.status_code} - ${error.response.data.error.message}`, { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        }
      }).finally(()=>{
        this.startAction = false;
      })
    },
    goBackToEventPage() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss">
.vertical-line {
  top: 4px;
  margin-top: 0px !important;
  margin: 0 10px !important;
  position: relative;
  height: 18px;
}
</style>
